import { exposeApi } from 'public/transport';
import wixWindow from 'wix-window';
import feraConfig from "public/config";
import wixApplication from 'wix-application';
import { checkIfFeraNeedsSetup } from 'public/fera_api_service';
import wixEditor from 'wix-editor';
import wixWidget from 'wix-widget';

let productId = ''

const api = {
    getProductId: () => productId
};

export async function setProp(key, value) {
	const props = await wixWidget.getProps();
	await wixWidget.setProps({...props, [key]: value});
}

export function setupEmOption({props, attributeId, elementId, defaultValue}) {
	let emValue = props[attributeId] ?? defaultValue;
	if (typeof emValue === 'number') emValue = defaultValue;
	const el = $w(`#${ elementId }`);
	el.value = Math.round(parseFloat(emValue.replace(/em$/i, '')) * 100);

	el.onChange((evt) => {
		const percent = evt.target.value;
		const emVal = Math.round(parseFloat(percent)) / 100;
		setProp(attributeId, `${ emVal.toString().replace(/\.0+$/, '') }em`)
	});
}

export async function buildWidgetPlugin({ $widget, $element, typeName, type, forProduct, defaultSettings }) {
    const viewMode = wixWindow.viewMode;

    console.log(`[Fera Wix Plugin] [${ typeName }] Initialized!`);

    const isDesignMode = viewMode !== 'Site';
    $element.setAttribute('data-design-mode', isDesignMode);

    const appInstance = wixApplication.getAppInstance();
    let appInstanceId = JSON.parse(atob(appInstance.toString().split('.')[1])).instanceId;
    if (appInstanceId == '68e691c4-d2b9-4e25-86dc-59bb48670dd4') {
        $element.setAttribute('data-api-key', 'pk_example');
    } else {
        $element.setAttribute('data-app-instance', appInstanceId);
    }

    const needsSetup = await checkIfFeraNeedsSetup(appInstanceId);
    $element.setAttribute('data-fera-needs-setup', needsSetup);

    if (needsSetup) {
        const checkInterval = setInterval(() => {
            if (!$element) return clearInterval(checkInterval);
            
            checkIfFeraNeedsSetup(appInstanceId).then((needsSetup) => {
                if (!needsSetup) {
                    $element.setAttribute('data-fera-needs-setup', false);
                    clearInterval(checkInterval);
                }
            });
        }, 2500);
    }

    $element.setAttribute('data-fera-container', type);

    if (isDesignMode) {
        $element.setAttribute('data-rating-count', 123);
        $element.setAttribute('data-rating-average', 4.9);
        if (forProduct) $element.setAttribute('data-product-id', "EXAMPLE");
    }
    $element.setAttribute('data-editor', "wix_site_editor");
    $element.setAttribute('data-block-id', `${ type }-${ Math.random()*99999*(new Date().getTime()) }`);

    $element.setAttribute('data-settings', JSON.stringify(defaultSettings));
    exposeApi($element, api);

    $widget.onPropsChanged((oldProps, newProps) => {
        console.log(`[Fera Wix Plugin] [${ typeName }] onPropsChanged/PROPS`, oldProps, newProps);

        productId = newProps.resourceId;
        $element.setAttribute('data-props', JSON.stringify(newProps));

        const settings = { ...defaultSettings, ...newProps };
        $element.setAttribute('data-settings', JSON.stringify(settings));

        if (forProduct) $element.setAttribute('data-product-id', productId || (isDesignMode ? 'EXAMPLE' : ''));
    });
}

export async function setupAppInstallationCheck() {
	const appInstance = wixApplication.getAppInstance();
	console.log('[Fera Wix Plugin] Loaded app instance', appInstance);
	const appInstanceId = JSON.parse(atob(appInstance.toString().split('.')[1])).instanceId;

	if ($w('#installRequiredPanel')) $w('#installRequiredPanel').onClick((event) => {
		wixEditor.openDashboardPanel({url: `app/${ feraConfig.wixAppId }` }); 
	});

	let neededSetup = false;
	let needsSetup = await checkIfFeraNeedsSetup(appInstanceId);
	if (needsSetup) {
		neededSetup = true;
		const stillNeedChecker = setInterval(() => {
			checkIfFeraNeedsSetup(appInstanceId).then((stillNeedsSetup) => {
				if (!stillNeedsSetup) {
					clearInterval(stillNeedChecker);
					$w('#installRequiredPanel').label = "PLEASE REFRESH THE EDITOR";
					$w('#installRequiredPanel').disable();
				}
			});
		}, 2000);
		$w('#installRequiredPanel').expand();
	} else {
		$w('#installRequiredPanel').collapse();
	}
}
